<template>
  <div class="skuImgBox">
    <div class="imgBox" v-if="datas?.skuPics?.length">
      <img v-for="item in datas.skuPics" :src="item" class="img" :key="item" />
    </div>
    <div class="imgBox" v-else>
      <img v-for="item in datas.detailPics" :src="item" class="img" :key="item" />
    </div>
    <div v-if="datas?.description" class="describeBox">
      <p class="title">描述信息：</p>
      <p class="describe">{{ datas?.description || '暂无描述' }}</p>
    </div>
    <div v-if="datas?.useDescription" class="describeBox">
      <p class="title">使用限制信息：</p>
      <p class="describe">{{ datas?.useDescription || '暂无使用限制' }}</p>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'

export default {
  props: ['datas'],
  setup(props, { emit }) {
    let { datas } = toRefs(props)
    const state = reactive({
      datas
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.skuImgBox {
  padding-bottom: calc(10px + constant(safe-area-inset-bottom));
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
}
.imgBox {
  font-size: 0;
  position: relative;
}
.imgBox::after {
  content: '111';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  // border: 1px solid red;
}
.img {
  width: 100%;
}
.describeBox {
  background: #fff;
  padding-bottom: 20px;
  .title {
    padding: 20px 0 10px;
    font-size: 14px;
  }
  .title::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    margin: 0 6px 1px 20px;
    border: 1px solid #3088c5;
    border-radius: 50%;
  }
  .describe {
    padding: 0 20px;
    font-size: 12px;
    line-height: 22px;
  }
}
.describeBox + .describeBox {
  padding-bottom: calc(40px + constant(safe-area-inset-bottom));
  padding-bottom: calc(40px + env(safe-area-inset-bottom));
  .title {
    border-top: 1px solid #f5f5f5;
  }
}
</style>
